// @core/api/endpoints/calendar/cancel_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelEventRequest,
  EventResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Cancel event
 * Cancels the event and notifies all attendees. The event remains visible with CANCELLED status. Use DeleteEvent for permanent removal.
 */
export async function CancelEvent(
  event_id: string,
  data: CancelEventRequest,
  options?: RequestOptions
): Promise<EventResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/events/:event_id/cancel`;
  requestPath = requestPath.replace(':event_id', encodeURIComponent(event_id));
  const requestOptions = options;
  return client.post<EventResponse>(requestPath, data, requestOptions);
}
